import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { AppInsightsService } from 'src/app/services/common/appinsights.service';

@Injectable({
  providedIn: 'root'
})
export class NavBarMenuService {
  visible: boolean;
  private url: string;

  constructor(appConfigService: AppConfigService,
    private http: HttpClient, private appInsights: AppInsightsService) {
    this.visible = false;    
    

    this.url = appConfigService.get('apiUrl');    
  }

  getUserRoleBasedMenu(menuType: any): Observable<any> {
    this.appInsights.logEvent("getUserRoleBasedMenu");
    var body = {
      MenuType: menuType.toString()
    };
    
    return this.http.post(this.url + '/Master/GetUserRoleBasedMenu', body) //
      .pipe(
        map(response => response),
        catchError(response => {
          this.appInsights.logException(response);
          return throwError(response);
        })
      );
  }

  hide() { this.visible = false; }

  show() { this.visible = true; }
}
